export const colors = {
  0: '#EE1111',
  5: '#E24343',
  10: '#F35656',
  15: '#F46363',
  20: '#F76E43',
  25: '#F98966',
  30: '#F19172',
  35: '#E09270',
  40: '#D79173',
  45: '#BEAD17',
  50: '#DECC28',
  55: '#E9D94D',
  60: '#F4E456',
  65: '#F3E458',
  70: '#BFE968',
  75: '#A6E425',
  80: '#96D90C',
  85: '#85BF0E',
  90: '#37DC47',
  95: '#2AD73B',
  100: '#11B521',
};
